import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { PharmaceuticalProduct } from "../../../Data/Art57Data/PharmaceuticalProduct";
import { Art57Node } from "../Art57Node";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNodeDrugIngredientsList } from "../ListEntity/TreeNodeDrugIngredientsList";
import { TreeNodeDrugRouteList } from "../ListEntity/TreeNodeDrugRouteList";
import { TreeNodeMedicalDeviceList } from "../ListEntity/TreeNodeMedicalDeviceList";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { TreeNodeOldDrugIngredientsList } from "../ListEntity/TreeNodeOldDrugIngredientsList";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodePharmaceuticalProduct extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new PharmaceuticalProduct(new FieldDefinition(injector)),
        'Pharmaceutical Product{param}'
      );
      this.parent = parent;
      this.labelNodeName = 'Pharmaceutical Product';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(lazy:boolean=true): void {
      if (this.data && this.data.model &&
        this.data.model.pharmformcode &&
        this.data.model.pharmformcode.value) {
          if (this.data.model.pharmformcode.name) {
            this.label = this.data.model.pharmformcode.name;                
          
          } else if (!lazy) {
            this.ioc!.get(LookupGetService).getLookup('pharmform',this.data.model.pharmformcode.value)
            .then((result: CodeName) => {
              if (result && result.name && result.name != '') {
                this.data.model.pharmformcode.name = result.name;
                this.refreshLabel();
              } else {
                this.label = this.labelTemplate.replace('{param}', '');
              }
            });
          }   
        } else {
          this.label = this.labelTemplate.replace('{param}', '');
        } 
    }
  
    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.pharmformcode
          ? this.data.model.pharmformcode.value
          : 'Not selected',
        this.data.model && this.data.model.pharmformcode
          ? this.data.model.pharmformcode.name
          : 'Pharmaceutical product',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodePharmaceuticalProduct =
        new TreeNodePharmaceuticalProduct(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }

    override setMessage(jsonObject: any): void {
      super.setMessage(jsonObject);
                 
      // Import Children Nodes
      if (jsonObject.adminroutes) {
        Art57NodeUtils.importNodeType(this,jsonObject.adminroutes, 'adminroute',TreeNodeDrugRouteList);
      }

      // import drug ingredients nodes
      if (jsonObject.activeingredients) {
        jsonObject.activeingredients.activeingredient =  jsonObject.activeingredients.activeingredient.map((items: any) => ({
          ...items,
          roleofingredient: 1
        }));
        Art57NodeUtils.importNodeType(this,jsonObject.activeingredients, 'activeingredient',TreeNodeDrugIngredientsList,{roleofingredient:1});
      }

      if (jsonObject.adjuvants) {
        jsonObject.adjuvants.adjuvant =  jsonObject.adjuvants.adjuvant.map((items: any) => ({
          ...items,
          roleofingredient: 3
        }));
         Art57NodeUtils.importNodeType(this,jsonObject.adjuvants, 'adjuvant',TreeNodeDrugIngredientsList,{roleofingredient:3});
      }

      if (jsonObject.excipients) {
        jsonObject.excipients.excipient =  jsonObject.excipients.excipient.map((items: any) => ({
          ...items,
          roleofingredient: 2
        }));
        Art57NodeUtils.importNodeType(this,jsonObject.excipients, 'excipient',TreeNodeDrugIngredientsList,{roleofingredient:2});
      }

      if (jsonObject.olddrugingredients) {
          Art57NodeUtils.importNodeType(this,jsonObject.olddrugingredients, 'oldDrugIngredient',TreeNodeOldDrugIngredientsList,{});
      }

      // Import old medical devices
      if (jsonObject.medicaldevices) {
        Art57NodeUtils.importNodeType(this,jsonObject.medicaldevices, 'medicaldevice',TreeNodeMedicalDeviceList);
      }

    }
  }